import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { TakeAccountComponent } from './pages/take-account/take-account.component';
import { SharedModule } from '../shared/shared.module';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { LocalMaterialModule } from 'src/app/shared/modules/material/material.module';
import { LocalFontAwesome } from 'src/app/shared/modules/fontawesome/fontawesome.module';
import { HttpClientModule } from '@angular/common/http';
import { EditIndicationComponent } from './pages/edit-indication/edit-indication.component';
import { DoctorsComponent } from './pages/doctors/doctors.component';
import { AddDoctorModalComponent } from './pages/doctors/add-doctor-modal/add-doctor-modal.component';
import { CasesAdminComponent } from './pages/cases-admin/cases-admin.component';
import { RegisterCaseComponent } from './pages/cases-admin/register-case/register-case.component';
import { AvailableCasesAdminComponent } from './pages/cases-admin/available-cases-admin/available-cases-admin.component';
import { CommunicareScheduleWebhook } from './pages/communicare-schedule-webhook/communicare-schedule-webhook.component';
import { InvoiceDoctorComponent } from './pages/invoice-doctor/invoice-doctor.component';

@NgModule({
  imports: [
    SharedModule,
    MatTableModule,
    MatToolbarModule,
    MatButtonModule,
    BrowserModule,
    LocalMaterialModule,
    LocalFontAwesome,
    HttpClientModule
  ],
  declarations: [
    TakeAccountComponent,
    EditIndicationComponent,
    DoctorsComponent,
    AddDoctorModalComponent,
    CasesAdminComponent,
    RegisterCaseComponent,
    AvailableCasesAdminComponent,
    CommunicareScheduleWebhook,
    InvoiceDoctorComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AdminModule {}
